import { useState, FC, useEffect } from 'react'
import { Button, Flex, Form, FormInstance, Input, Modal, message } from 'antd'
import { changePassword } from '../api/auth'

export const ChangePassword: FC = () => {
	const [open, setOpen] = useState(false)
	const [confirmLoading, setConfirmLoading] = useState(false)
	const [form] = Form.useForm()

	const showModal = () => {
		setOpen(true)
	}

	const SubmitButton = ({ form }: { form: FormInstance }) => {
		const [submittable, setSubmittable] = useState(false)
		const values = Form.useWatch([], form)

		useEffect(() => {
			form.validateFields({ validateOnly: true }).then(
				() => {
					setSubmittable(true)
				},
				() => {
					setSubmittable(false)
				}
			)
		}, [values, form])
		return (
			<Button
				type="primary"
				style={{
					backgroundColor: 'var(--green)',
					color: '#fff',
					borderColor: 'var(--green)'
				}}
				htmlType="submit"
				disabled={!submittable}
				onClick={handleOk}
				loading={confirmLoading}
				size="large"
				block>
				Подтвердить
			</Button>
		)
	}

	const handleOk = async () => {
		try {
			const values = await form.validateFields()
			if (values.newPassword !== values.confirmPassword) {
				message.error('Пароли не совпадают')
				return
			}
			setConfirmLoading(true)
			await changePassword(values.oldPassword, values.newPassword)
			message.success('Пароль успешно изменён')
			setOpen(false)
			form.resetFields()
		} catch (err: any) {
			const msg = err?.response?.data?.message || 'Ошибка при смене пароля'
			message.error(msg)
		} finally {
			setConfirmLoading(false)
		}
	}

	const handleCancel = () => {
		setOpen(false)
		form.resetFields()
	}

	return (
		<>
			<Button type="primary" onClick={showModal} size="large">
				Сменить пароль
			</Button>
			<Modal
				title={<h2 style={{ margin: 0 }}>Смена пароля</h2>}
				open={open}
				onOk={handleOk}
				confirmLoading={confirmLoading}
				onCancel={handleCancel}
				footer={null}>
				<Form
					name="changePassword"
					layout="vertical"
					autoComplete="off"
					form={form}>
					<Form.Item
						name="oldPassword"
						label="Текущий пароль"
						rules={[{ required: true, min: 8, message: 'Минимум 8 символов' }]}>
						<Input.Password size="large" />
					</Form.Item>
					<Form.Item
						name="newPassword"
						label="Новый пароль"
						rules={[{ required: true, min: 8, message: 'Минимум 8 символов' }]}>
						<Input.Password size="large" />
					</Form.Item>
					<Form.Item
						name="confirmPassword"
						label="Подтвердите пароль"
						rules={[
							{ required: true, min: 8, message: 'Минимум 8 символов' },
							({ getFieldValue }) => ({
								validator(_, value) {
									if (!value || getFieldValue('newPassword') === value) {
										return Promise.resolve()
									}
									return Promise.reject(new Error('Пароли не совпадают'))
								}
							})
						]}>
						<Input.Password size="large" />
					</Form.Item>
				</Form>
				<Flex gap="small">
					<Button
						onClick={handleCancel}
						size="large"
						block
						style={{
							backgroundColor: 'var(--gray)',
							color: '#fff',
							borderColor: 'var(--gray)'
						}}>
						Отмена
					</Button>
					<SubmitButton form={form} />
				</Flex>
			</Modal>
		</>
	)
}
